// Б.2.b: Массовая прошивка (syn_massovaya_proshivka, action, epic, init=3).
//
// Без picker'а (массовый эффект).
//
// Эффект:
//   1. Каждый союзный юнит на поле получает один случайный Мод Синтетикса
//      через стандартный attachMod. Пул случайности — все 8 Модов фракции.
//      Для каждого юнита — отдельный бросок.
//   2. Бросок монетки 50% (state.rng.int(2) === 0). Если выпало — каждый
//      ВРАЖЕСКИЙ юнит на поле тоже получает один случайный Мод (тот же пул).
//   3. Перегрузка наступает как обычно (3+ Модов на юните → смерть в Ф1
//      следующего раунда). Посмертие через onUnitDied срабатывает.
//   4. Триггер Бишора срабатывает на КАЖДЫЙ Мод, повешенный на союзника
//      (каскадно через attachMod). На Моды на врагов Бишор не реагирует.
//   5. Триггер Хирурга НЕ срабатывает: attachMod вызывается БЕЗ source.isPlayed
//      (Прошивка — это эффект Действия, не «розыгрыш Мода с руки»).
//   6. Счётчик прогрессии Синтетикса (modPlaysCount) НЕ тикает.

import { attachMod } from './modifications.js';
import { cards as cardsSyn } from '../../../data/cards-syntetics.js';

export const CARD_ID = 'syn_massovaya_proshivka';

// Пул всех 8 Модов Синтетикса.
function modPool() {
  return cardsSyn.filter(c => c.type === 'mod');
}

export function resolveProshivka(state, playerIdx) {
  const me    = state.players[playerIdx];
  const enemy = state.players[1 - playerIdx];
  const pool = modPool();
  if (pool.length === 0) {
    state.log.add(`📡 ${me.name}: Массовая прошивка — пул Модов пуст`);
    return { ok: false, reason: 'no_mods' };
  }

  state.log.add(`📡 ${me.name}: Массовая прошивка — союзникам выдаются случайные Моды`);
  // Снимок союзников: новые Моды могут вызвать Перегрузку, но юнит сам
  // умрёт только в Ф1 следующего хода — итерация безопасна.
  const allies = me.unitsOnField();
  for (const u of allies) {
    if (!u.isAlive()) continue;
    const tpl = pool[state.rng.int(pool.length)];
    attachMod(state, u, { id: tpl.id, name_ru: tpl.name_ru }, {
      cardId: CARD_ID, ownerIdx: playerIdx
      // НЕТ isPlayed — Хирург не реагирует, прогрессия не тикает.
    });
  }

  // Монетка 50%.
  const coin = state.rng.int(2);
  if (coin === 0) {
    state.log.add(`📡 ${me.name}: Массовая прошивка — 🪙 врагам тоже!`);
    const enemies = enemy.unitsOnField();
    for (const u of enemies) {
      if (!u.isAlive()) continue;
      const tpl = pool[state.rng.int(pool.length)];
      attachMod(state, u, { id: tpl.id, name_ru: tpl.name_ru }, {
        cardId: CARD_ID, ownerIdx: playerIdx
        // attachMod применит Бишора у владельца Мода (ownerIdx внутри функции
        // берётся из targetCard.ownerId), а Бишор на стороне ИГРОКА — реагирует
        // на «союзный получил Мод», то есть НЕ на этих врагов. Корректно.
      });
    }
  } else {
    state.log.add(`📡 ${me.name}: Массовая прошивка — 🪙 врагов не задело`);
  }
  return { ok: true };
}
